import { createAsyncThunk } from "@reduxjs/toolkit";
import { companySliceName } from "..";
import server from "../../../../config/server";

export const getEmailTemplatesAction = createAsyncThunk(`${companySliceName}/getEmailTemplates`, async (_, thunkAPI) => {
  try {
    const response = await server.get("/app/company/email/templates", {}, {});
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const saveEmailTemplateAction = createAsyncThunk(`${companySliceName}/saveEmailTemplate`, async (template, thunkAPI) => {
  try {
    const response = await server.post("/app/company/email/template", template);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});
